module.exports = __webpack_public_path__ + "img/ico-abort_order.b3fcc07d.svg";